import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapSubjectService {
  public notifyChangesInMap: Subject<any>;

  constructor() {
    this.notifyChangesInMap = new Subject();
  }
  public notifyOtherChangesInMap(data: any[]) {
    this.notifyChangesInMap.next(data);
  }
  getEventDetail(): Observable<Event> {
    return this.notifyChangesInMap.asObservable();
  }
}
